// src/frontend/src/api/simulationApi.ts
import api from './api';

// Stakeholder persona API services
export const stakeholderService = {
  getStakeholders: () => api.get('/stakeholders'),
  getStakeholderById: (id: string) => api.get(`/stakeholders/${id}`),
  createStakeholder: (data: any) => api.post('/stakeholders', data),
  updateStakeholder: (id: string, data: any) => api.put(`/stakeholders/${id}`, data),
  deleteStakeholder: (id: string) => api.delete(`/stakeholders/${id}`),
  generateStakeholder: (data: any) => api.post('/stakeholders/generate', data),
};

// Custom Scenario API services
export const customScenarioService = {
  getCustomScenarios: () => api.get('/custom-scenarios'),
  getCustomScenarioById: (id: string) => api.get(`/custom-scenarios/${id}`),
  createCustomScenario: (data: any) => api.post('/custom-scenarios', data),
  generateScenarioFromTemplate: (id: string) => api.post(`/custom-scenarios/${id}/generate`),
};

// Simulation scenario API services
export const scenarioService = {
  getScenarios: () => api.get('/scenarios'),
  getScenarioById: (id: string) => api.get(`/scenarios/${id}`),
  createScenario: (data: any) => api.post('/scenarios', data),
  updateScenario: (id: string, data: any) => api.put(`/scenarios/${id}`, data),
  deleteScenario: (id: string) => api.delete(`/scenarios/${id}`),
  generateScenario: (data: any) => api.post('/scenarios/generate', data),
};

// Conversation API services
export const conversationService = {
  getConversations: () => api.get('/conversations'),
  getConversationById: (id: string) => api.get(`/conversations/${id}`),
  startConversation: (data: any) => api.post('/conversations', data),
  sendMessage: (id: string, message: string) => api.post(`/conversations/${id}/messages`, { message }),
  endConversation: (id: string) => api.post(`/conversations/${id}/end`),
  abandonConversation: (id: string) => api.post(`/conversations/${id}/abandon`),
  getCoachingTip: (id: string, message: string) => 
    api.post(`/conversations/${id}/coaching-tip`, { message }),
  
  // Streaming support
  sendMessageStream: (id: string, message: string) => {
    // Note: For EventSource, we handle this directly in the component
    // This is just for reference/documentation
    return new EventSource(
      `/conversations/${id}/messages?message=${encodeURIComponent(message)}`,
      {
        withCredentials: true
      }
    );
  },
  
  // PDF Export endpoints
  exportPDF: (id: string) => api.post(`/conversations/${id}/export/pdf`),
  getExportStatus: (jobId: string) => api.get(`/conversations/export/status/${jobId}`),
  downloadPDF: (filename: string) => 
    api.get(`/conversations/export/download/${filename}`, { responseType: 'blob' })
};

export default {
  stakeholderService,
  scenarioService,
  conversationService,
  customScenarioService
};
